export default "__VITE_ASSET__i_AnMOvN__"